export enum StorageItem {
  ACCESS_TOKEN = 'ACCESS_TOKEN',
  REFRESH_TOKEN = 'REFRESH_TOKEN',
  // ZOHO_TOKEN = 'ZOHO_TOKEN',
}
